import React from 'react';
import { WithStyles, createStyles } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import { Typography, FormControlLabel, Radio, Checkbox } from '@material-ui/core';

const styles = (theme: Theme) => createStyles({
  formControlLabelRoot: {
    marginRight: 0,
    marginLeft: 0,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: theme.palette.grey[300],
    borderRadius: 3,
    padding: theme.spacing.unit / 2,
    paddingRight: theme.spacing.unit,
    paddingLeft: theme.spacing.unit,
  },
  radioRoot: {
    padding: 0,
    paddingRight: theme.spacing.unit,
  },
  checkboxRoot: {
    padding: 0,
    paddingRight: theme.spacing.unit,
  },
});

export const DatePickerPreview = () => {
  return (
    <>
      <Typography variant="body2">Date Picker Preview</Typography>
    </>
  );
};

export const DropDownPreview = () => {
  return (
    <>
      <Typography variant="body2">Drop Down Preview</Typography>
    </>
  );
};

export const RadioOptionsPreview = withStyles(styles)(({ classes }: stylesProps) => {
  return (
    <FormControlLabel
      control={<Radio color="primary" classes={{ root: classes.radioRoot }} />}
      label="Compulsory"
      value="compulsory"
      checked
      classes={{
        root: classes.formControlLabelRoot
      }}
    />
  );
});

export const CheckboxOptionsPreview = withStyles(styles)(({ classes }: stylesProps) => {
  return (
    <FormControlLabel
      control={<Checkbox color="primary" classes={{ root: classes.checkboxRoot }} />}
      label="Compulsory"
      value="compulsory"
      checked
      classes={{
        root: classes.formControlLabelRoot
      }}
    />
  );
});

export const TextInputPreview = () => {
  return (
    <>
      <Typography variant="body2">Text Input Preview</Typography>
    </>
  );
};

interface stylesProps extends WithStyles<typeof styles> {
};

interface TagPreviewProps {
  tagType: string
};

const TagPreview = ({ tagType }: TagPreviewProps) => {
  return (
    <>
      {tagType === 'datePicker' && <DatePickerPreview />}
      {tagType === 'dropDown' && <DropDownPreview />}
      {tagType === 'radioOptions' && <RadioOptionsPreview />}
      {tagType === 'checkboxOptions' && <CheckboxOptionsPreview />}
      {tagType === 'textInput' && <TextInputPreview />}
    </>
  );
};

export default TagPreview;